import WelcomePage from 'feature/login-flow/welcome/welcome-page';

export default WelcomePage;
